/* ZAVYRO theme — carrito (AJAX de Shopify), selector de país y página de producto */
(function () {
  'use strict';

  var Z = window.ZAVYRO || {};
  var T = Z.t || {};
  var root = document.documentElement;
  var $ = function (id) { return document.getElementById(id); };

  /* ---------- utilidades ---------- */
  function money(cents) {
    var locales = [Z.locale, Z.lang, undefined];
    for (var i = 0; i < locales.length; i++) {
      try {
        return new Intl.NumberFormat(locales[i], { style: 'currency', currency: Z.currency || 'EUR' }).format(cents / 100);
      } catch (e) { /* prueba el siguiente */ }
    }
    return (cents / 100).toFixed(2) + ' ' + (Z.currency || '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function stars(n) { return '★'.repeat(n) + '☆'.repeat(5 - n); }

  /* bandas animadas: se duplica el contenido para el bucle continuo */
  document.querySelectorAll('.track').forEach(function (t) { t.innerHTML += t.innerHTML; });

  /* ---------- carrito ---------- */
  var drawer = $('drawer'), overlay = $('ov');

  function openCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (overlay) overlay.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open && $('cx')) $('cx').focus();
  }

  function cartRender(c) {
    var count = $('cc');
    if (count) count.textContent = c.item_count;
    var di = $('di'), df = $('df');
    if (!di || !df) return;

    if (!c.items.length) {
      di.innerHTML = '<p style="text-align:center;padding:56px 0;color:var(--mute)">' + esc(T.empty) + '</p>';
      df.innerHTML = '';
      return;
    }

    di.innerHTML = c.items.map(function (i) {
      var thumb = i.image
        ? '<img class="th" src="' + esc(i.image) + '" alt="">'
        : '<div class="th">🎁</div>';
      var variant = (i.variant_title && i.variant_title !== 'Default Title')
        ? '<span style="color:var(--mute);font-size:14px">' + esc(i.variant_title) + '</span><br>'
        : '';
      var price = '<b>' + money(i.final_line_price) + '</b>';
      if (i.original_line_price > i.final_line_price) {
        price += '<br><s style="color:var(--mute);font-size:13px">' + money(i.original_line_price) + '</s>';
      }
      return '<div class="ci">' + thumb +
        '<div><b>' + esc(i.product_title) + '</b><br>' + variant +
        '<div class="qty">' +
        '<button type="button" data-a="dec" data-k="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="' + esc(T.dec) + '">−</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button type="button" data-a="inc" data-k="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="' + esc(T.inc) + '">+</button>' +
        '</div></div>' +
        '<div style="text-align:right">' + price + '<br>' +
        '<button type="button" class="rm" data-a="rm" data-k="' + esc(i.key) + '">' + esc(T.remove) + '</button></div></div>';
    }).join('');

    df.innerHTML =
      '<div class="sr"><span>' + esc(T.subtotal) + '</span><span>' + money(c.total_price) + '</span></div>' +
      '<div class="sh"><span>' + esc(T.shipping) + '</span><b style="font-weight:600;letter-spacing:0">' + esc(T.shippingNote) + '</b></div>' +
      '<button class="buy" id="co" type="button">' + esc(T.checkout) + '</button>';
    $('co').onclick = function () { window.location.href = '/checkout'; };
  }

  function getCart() {
    return fetch(Z.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(Z.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(cartRender);
  }

  function addToCart(items) {
    return fetch(Z.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      if (!res.ok) {
        var m = $('msg');
        if (m) m.textContent = res.body.description || res.body.message || T.error;
        return;
      }
      return getCart().then(function (c) { cartRender(c); openCart(true); });
    }).catch(function () {
      var m = $('msg');
      if (m) m.textContent = T.error;
    });
  }

  if ($('cart')) $('cart').onclick = function () { openCart(true); };
  if ($('cx')) $('cx').onclick = function () { openCart(false); };
  if (overlay) overlay.onclick = function () { openCart(false); };

  if ($('di')) {
    $('di').onclick = function (e) {
      var b = e.target.closest('button[data-a]');
      if (!b) return;
      var q = parseInt(b.dataset.q, 10) || 0;
      if (b.dataset.a === 'inc') changeLine(b.dataset.k, q + 1);
      else if (b.dataset.a === 'dec') changeLine(b.dataset.k, Math.max(q - 1, 0));
      else changeLine(b.dataset.k, 0);
    };
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) {
      openCart(false);
      if ($('cart')) $('cart').focus();
    }
  });

  if (drawer) getCart().then(cartRender).catch(function () {});

  /* ---------- selector de país / moneda ---------- */
  (function () {
    var ll = $('ll'), lb = $('lb'), loc = $('loc');
    if (!ll || !lb || !loc) return;

    function openL(open) {
      ll.hidden = !open;
      lb.setAttribute('aria-expanded', String(open));
      if (open) {
        var sel = ll.querySelector('[aria-selected="true"] button') || ll.querySelector('button');
        if (sel) sel.focus();
      }
    }
    lb.onclick = function () { openL(ll.hidden); };
    document.addEventListener('click', function (e) { if (!loc.contains(e.target)) openL(false); });
    ll.addEventListener('keydown', function (e) {
      var btns = Array.prototype.slice.call(ll.querySelectorAll('button'));
      var i = btns.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); btns[Math.min(i + 1, btns.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); btns[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Escape') { e.stopPropagation(); openL(false); lb.focus(); }
    });
  })();

  /* ---------- página de producto ---------- */
  var barObserver = null;

  function initProduct() {
    var P = Z.product;
    if (!P || !$('buy') || !$('bd')) return;

    var colors = P.colors;
    var sizes = P.sizes || [];
    var hasColorOpt = P.colorPos > 0;
    var hasSizeOpt = P.sizePos > 0 && sizes.length > 0;
    var packs = { 1: 0, 2: (P.packs['2'] || 0) / 100, 3: (P.packs['3'] || 0) / 100 };
    var packList = P.showPacks ? [1, 2, 3] : [1];
    var bn = 1;
    var J = [0, 1, 2].map(function (i) { return { c: i % colors.length, s: '' }; });

    function opt(v, pos) { return pos > 0 ? v['o' + pos] : null; }

    function findVariant(c, s) {
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i];
        if (hasColorOpt && colors[c].v !== opt(v, P.colorPos)) continue;
        if (hasSizeOpt && s && s !== opt(v, P.sizePos)) continue;
        return v;
      }
      return null;
    }
    function sizeAvailable(c, s) {
      return P.variants.some(function (v) {
        return (!hasColorOpt || colors[c].v === opt(v, P.colorPos)) && s === opt(v, P.sizePos) && v.available;
      });
    }
    function colorImg(ci) {
      var c = colors[ci];
      if (hasColorOpt) {
        for (var i = 0; i < P.variants.length; i++) {
          var v = P.variants[i];
          if (v.img && v['o' + P.colorPos] === c.v) return v.img;
        }
      }
      return c.asset || P.fallbackImg;
    }
    function unit(j) {
      var v = findVariant(J[j].c, J[j].s);
      return v ? v.price : P.price;
    }
    function total() {
      var t = 0;
      for (var j = 0; j < bn; j++) t += unit(j);
      return t * (1 - packs[bn]);
    }
    function refresh() {
      var label = (P.buyLabel || 'Añadir al carrito') + ' · ' + money(total());
      $('buy').textContent = label;
      $('bp').textContent = money(total());
    }

    function gallery() {
      var cur = colors[J[0].c];
      root.style.setProperty('--accent', cur.hex);
      var main = colorImg(J[0].c);
      $('img').src = main;
      if ($('himg')) $('himg').src = main;
      $('img').alt = P.title + ' ' + cur.n;
      var tr = $('tr');
      tr.innerHTML = '';
      colors.forEach(function (x, ci) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tb';
        b.setAttribute('aria-pressed', String(ci === J[0].c));
        b.setAttribute('aria-label', x.n);
        var im = document.createElement('img');
        im.src = colorImg(ci);
        im.alt = '';
        b.appendChild(im);
        b.onclick = function () { J[0].c = ci; render(); };
        tr.appendChild(b);
      });
    }

    function step(d) {
      J[0].c = (J[0].c + d + colors.length) % colors.length;
      render();
    }
    $('tp').onclick = function () { step(-1); };
    $('tn').onclick = function () { step(1); };

    function render() {
      gallery();
      var box = $('bd');
      box.innerHTML = '';

      packList.forEach(function (n) {
        var full = 0, j;
        for (j = 0; j < n; j++) full += unit(j);
        var t = full * (1 - packs[n]);
        var o = document.createElement('div');
        o.className = 'bo';
        o.tabIndex = 0;
        o.setAttribute('role', 'radio');
        o.setAttribute('aria-checked', String(bn === n));
        o.innerHTML = '<div class="bh"><span class="rd"></span><div><b>' + n + (n === 1 ? T.jacket : T.jackets) + '</b><small>' +
          (packs[n] ? esc(T.save) + Math.round(packs[n] * 100) + '%' : esc(T.normal)) +
          '</small></div><div class="bp"><b>' + money(t) + '</b>' + (packs[n] ? '<s>' + money(full) + '</s>' : '') + '</div></div>';

        if (bn === n) {
          var w = document.createElement('div');
          w.className = 'jl';
          w.innerHTML = '<small>' + esc(hasColorOpt ? T.colorSize : T.size) + '</small>';
          for (j = 0; j < n; j++) (function (j) {
            var r = document.createElement('div');
            r.className = 'jr';
            var x = colors[J[j].c];
            var html = '<img src="' + esc(colorImg(J[j].c)) + '" alt="">';
            if (hasColorOpt) {
              html += '<div class="sel"><i style="background:' + esc(x.hex) + '"></i><select aria-label="' + esc(T.color) + ' ' + (j + 1) + '">' +
                colors.map(function (c, ci) {
                  return '<option value="' + ci + '"' + (ci === J[j].c ? ' selected' : '') + '>' + esc(c.n) + '</option>';
                }).join('') + '</select></div>';
            }
            if (hasSizeOpt) {
              html += '<div class="sel"><select aria-label="' + esc(T.size) + ' ' + (j + 1) + '"><option value="">' + esc(T.size) + '</option>' +
                sizes.map(function (s) {
                  var ok = sizeAvailable(J[j].c, s);
                  return '<option value="' + esc(s) + '"' + (J[j].s === s ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(s) + (ok ? '' : ' (agotada)') + '</option>';
                }).join('') + '</select></div>';
            }
            r.innerHTML = html;
            var q = r.querySelectorAll('select'), k = 0;
            if (hasColorOpt) {
              q[k++].onchange = function (e) {
                J[j].c = parseInt(e.target.value, 10);
                if (J[j].s && !sizeAvailable(J[j].c, J[j].s)) J[j].s = '';
                render();
              };
            }
            if (hasSizeOpt) {
              q[k].onchange = function (e) { J[j].s = e.target.value; $('msg').textContent = ''; refresh(); };
            }
            w.appendChild(r);
          })(j);
          o.appendChild(w);
        }
        o.onclick = function (e) { if (e.target.closest('.jl')) return; bn = n; render(); };
        o.onkeydown = function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target === o) { e.preventDefault(); bn = n; render(); }
        };
        box.appendChild(o);
      });
      refresh();
    }

    function buyNow() {
      var msg = $('msg'), j;
      msg.textContent = '';
      if (hasSizeOpt) {
        for (j = 0; j < bn; j++) {
          if (!J[j].s) {
            msg.textContent = T.pickSize + (j + 1) + '.';
            $('comprar').scrollIntoView();
            return;
          }
        }
      }
      var lines = {}, order = [];
      for (j = 0; j < bn; j++) {
        var v = findVariant(J[j].c, J[j].s);
        if (!v || !v.available) { msg.textContent = T.soldOut; return; }
        if (!lines[v.id]) { lines[v.id] = 0; order.push(v.id); }
        lines[v.id]++;
      }
      var items = order.map(function (id) { return { id: id, quantity: lines[id] }; });
      [$('buy'), $('bb')].forEach(function (b) { if (b) b.disabled = true; });
      addToCart(items).then(function () {
        [$('buy'), $('bb')].forEach(function (b) { if (b) b.disabled = false; });
      });
    }
    $('buy').onclick = buyNow;
    $('bb').onclick = buyNow;

    /* reseñas */
    var R = P.reviews || [];
    if (R.length) {
      var avg = R.reduce(function (t, r) { return t + r.s; }, 0) / R.length;
      if ($('stars')) $('stars').textContent = stars(Math.round(avg));
      if ($('rtxt')) $('rtxt').textContent = avg.toFixed(1).replace('.', ',') + ' (' + R.length + ')';
      if ($('rl')) {
        $('rl').innerHTML = R.map(function (r, i) {
          var img = r.img || colorImg(i % colors.length);
          return '<article class="rc"><img src="' + esc(img) + '" alt="Foto de producto" loading="lazy">' +
            '<div class="stars" style="margin-top:10px">' + stars(r.s) + '</div><h3>' + esc(r.h) + '</h3><p>' + esc(r.t) + '</p>' +
            '<p style="margin-top:8px;font-size:12px">' + esc(r.n) + ' · ' + esc(r.c) + '</p></article>';
        }).join('');
      }
      var ri = 0;
      var mini = function () {
        var r = R[ri];
        if (!$('mr')) return;
        $('mr').innerHTML = '<div class="av">' + esc((r.n || '?').charAt(0)) + '</div><div><p>' + esc(r.t) + '</p><small>' + esc(r.n) + ' · <span class="stars">' + stars(r.s) + '</span></small></div>';
        $('dots').innerHTML = '';
        R.forEach(function (_, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-pressed', String(k === ri));
          b.setAttribute('aria-label', 'Reseña ' + (k + 1));
          b.onclick = function () { ri = k; mini(); };
          $('dots').appendChild(b);
        });
      };
      mini();
    }

    /* barra fija de compra */
    var bar = $('bar');
    if (barObserver) barObserver.disconnect();
    if (bar && 'IntersectionObserver' in window) {
      barObserver = new IntersectionObserver(function (e) {
        bar.classList.toggle('on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      barObserver.observe($('buy'));
    }

    render();
  }

  function boot() { initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initProduct(); });
})();
